"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wordifyCamelCase = void 0;
var wordifyCamelCase = function (camelCasedName) {
    var _a;
    return (_a = camelCasedName
        .split(".")
        .pop()) === null || _a === void 0 ? void 0 : _a.replace(/([A-Z])/g, " $1").replace(/^./, function (uncapitalisedWord) { return uncapitalisedWord.toUpperCase(); });
};
exports.wordifyCamelCase = wordifyCamelCase;
//# sourceMappingURL=WordifyCamelCase.js.map